<template>
  <div class="l-block-head">
      <h1 class="title">
        {{ title }}
      </h1>
      <span class="icon-line"></span>
  </div>
</template>

<script>
export default {
    name: 'l-block-head',
    props:{
        title:{
            default: ''
        }
    }
}
</script>
<style lang="scss" scoped>
.l-block-head{
    margin: 100px auto;
    text-align: center;
}

.title{
    display: block;
    margin-bottom: 40px;
    font-size: $font_size_title;
    color: $font_color_title;
}

.icon-line{
    display: inline-block;
    width: 160px;
    height: 2px;
    background: url('../assets/img/line.png') no-repeat center;
    background-size: 100%; 
}

</style>